import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isArray',
})
export class IsArrayPipe implements PipeTransform {
    transform(val: any): boolean {
        return Array.isArray(val);
    }
}
